/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TablesTableNameRouteImport } from './routes/tables/$tableName'
import { Route as CustomTradesRouteImport } from './routes/custom/trades'
import { Route as CustomSidelineReviewRouteImport } from './routes/custom/sideline-review'
import { Route as CustomSidelineMonitorRouteImport } from './routes/custom/sideline-monitor'
import { Route as CustomSidelineRouteImport } from './routes/custom/sideline'
import { Route as CustomCourtsideReviewRouteImport } from './routes/custom/courtside-review'
import { Route as CustomCourtsideMonitorRouteImport } from './routes/custom/courtside-monitor'
import { Route as CustomCourtsideRouteImport } from './routes/custom/courtside'
import { Route as CustomAgentsRouteImport } from './routes/custom/agents'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TablesTableNameRoute = TablesTableNameRouteImport.update({
  id: '/tables/$tableName',
  path: '/tables/$tableName',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomTradesRoute = CustomTradesRouteImport.update({
  id: '/custom/trades',
  path: '/custom/trades',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomSidelineReviewRoute = CustomSidelineReviewRouteImport.update({
  id: '/custom/sideline-review',
  path: '/custom/sideline-review',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomSidelineMonitorRoute = CustomSidelineMonitorRouteImport.update({
  id: '/custom/sideline-monitor',
  path: '/custom/sideline-monitor',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomSidelineRoute = CustomSidelineRouteImport.update({
  id: '/custom/sideline',
  path: '/custom/sideline',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomCourtsideReviewRoute = CustomCourtsideReviewRouteImport.update({
  id: '/custom/courtside-review',
  path: '/custom/courtside-review',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomCourtsideMonitorRoute = CustomCourtsideMonitorRouteImport.update({
  id: '/custom/courtside-monitor',
  path: '/custom/courtside-monitor',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomCourtsideRoute = CustomCourtsideRouteImport.update({
  id: '/custom/courtside',
  path: '/custom/courtside',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomAgentsRoute = CustomAgentsRouteImport.update({
  id: '/custom/agents',
  path: '/custom/agents',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/custom/agents': typeof CustomAgentsRoute
  '/custom/courtside': typeof CustomCourtsideRoute
  '/custom/courtside-monitor': typeof CustomCourtsideMonitorRoute
  '/custom/courtside-review': typeof CustomCourtsideReviewRoute
  '/custom/sideline': typeof CustomSidelineRoute
  '/custom/sideline-monitor': typeof CustomSidelineMonitorRoute
  '/custom/sideline-review': typeof CustomSidelineReviewRoute
  '/custom/trades': typeof CustomTradesRoute
  '/tables/$tableName': typeof TablesTableNameRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/custom/agents': typeof CustomAgentsRoute
  '/custom/courtside': typeof CustomCourtsideRoute
  '/custom/courtside-monitor': typeof CustomCourtsideMonitorRoute
  '/custom/courtside-review': typeof CustomCourtsideReviewRoute
  '/custom/sideline': typeof CustomSidelineRoute
  '/custom/sideline-monitor': typeof CustomSidelineMonitorRoute
  '/custom/sideline-review': typeof CustomSidelineReviewRoute
  '/custom/trades': typeof CustomTradesRoute
  '/tables/$tableName': typeof TablesTableNameRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/custom/agents': typeof CustomAgentsRoute
  '/custom/courtside': typeof CustomCourtsideRoute
  '/custom/courtside-monitor': typeof CustomCourtsideMonitorRoute
  '/custom/courtside-review': typeof CustomCourtsideReviewRoute
  '/custom/sideline': typeof CustomSidelineRoute
  '/custom/sideline-monitor': typeof CustomSidelineMonitorRoute
  '/custom/sideline-review': typeof CustomSidelineReviewRoute
  '/custom/trades': typeof CustomTradesRoute
  '/tables/$tableName': typeof TablesTableNameRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/custom/agents'
    | '/custom/courtside'
    | '/custom/courtside-monitor'
    | '/custom/courtside-review'
    | '/custom/sideline'
    | '/custom/sideline-monitor'
    | '/custom/sideline-review'
    | '/custom/trades'
    | '/tables/$tableName'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/custom/agents'
    | '/custom/courtside'
    | '/custom/courtside-monitor'
    | '/custom/courtside-review'
    | '/custom/sideline'
    | '/custom/sideline-monitor'
    | '/custom/sideline-review'
    | '/custom/trades'
    | '/tables/$tableName'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/custom/agents'
    | '/custom/courtside'
    | '/custom/courtside-monitor'
    | '/custom/courtside-review'
    | '/custom/sideline'
    | '/custom/sideline-monitor'
    | '/custom/sideline-review'
    | '/custom/trades'
    | '/tables/$tableName'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  CustomAgentsRoute: typeof CustomAgentsRoute
  CustomCourtsideRoute: typeof CustomCourtsideRoute
  CustomCourtsideMonitorRoute: typeof CustomCourtsideMonitorRoute
  CustomCourtsideReviewRoute: typeof CustomCourtsideReviewRoute
  CustomSidelineRoute: typeof CustomSidelineRoute
  CustomSidelineMonitorRoute: typeof CustomSidelineMonitorRoute
  CustomSidelineReviewRoute: typeof CustomSidelineReviewRoute
  CustomTradesRoute: typeof CustomTradesRoute
  TablesTableNameRoute: typeof TablesTableNameRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tables/$tableName': {
      id: '/tables/$tableName'
      path: '/tables/$tableName'
      fullPath: '/tables/$tableName'
      preLoaderRoute: typeof TablesTableNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custom/trades': {
      id: '/custom/trades'
      path: '/custom/trades'
      fullPath: '/custom/trades'
      preLoaderRoute: typeof CustomTradesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custom/sideline-review': {
      id: '/custom/sideline-review'
      path: '/custom/sideline-review'
      fullPath: '/custom/sideline-review'
      preLoaderRoute: typeof CustomSidelineReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custom/sideline-monitor': {
      id: '/custom/sideline-monitor'
      path: '/custom/sideline-monitor'
      fullPath: '/custom/sideline-monitor'
      preLoaderRoute: typeof CustomSidelineMonitorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custom/sideline': {
      id: '/custom/sideline'
      path: '/custom/sideline'
      fullPath: '/custom/sideline'
      preLoaderRoute: typeof CustomSidelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custom/courtside-review': {
      id: '/custom/courtside-review'
      path: '/custom/courtside-review'
      fullPath: '/custom/courtside-review'
      preLoaderRoute: typeof CustomCourtsideReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custom/courtside-monitor': {
      id: '/custom/courtside-monitor'
      path: '/custom/courtside-monitor'
      fullPath: '/custom/courtside-monitor'
      preLoaderRoute: typeof CustomCourtsideMonitorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custom/courtside': {
      id: '/custom/courtside'
      path: '/custom/courtside'
      fullPath: '/custom/courtside'
      preLoaderRoute: typeof CustomCourtsideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custom/agents': {
      id: '/custom/agents'
      path: '/custom/agents'
      fullPath: '/custom/agents'
      preLoaderRoute: typeof CustomAgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  CustomAgentsRoute: CustomAgentsRoute,
  CustomCourtsideRoute: CustomCourtsideRoute,
  CustomCourtsideMonitorRoute: CustomCourtsideMonitorRoute,
  CustomCourtsideReviewRoute: CustomCourtsideReviewRoute,
  CustomSidelineRoute: CustomSidelineRoute,
  CustomSidelineMonitorRoute: CustomSidelineMonitorRoute,
  CustomSidelineReviewRoute: CustomSidelineReviewRoute,
  CustomTradesRoute: CustomTradesRoute,
  TablesTableNameRoute: TablesTableNameRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
